import { IApiUserIndex } from "@Types/api";
import { get, post, postGeneric } from "./index";
import * as ts from "@Types/api";
import { path, host } from "./url";

// 找車頁 - 銷售排行
export async function fetchGetNewCarSalesRankData(params?: {
  y: number;
  m: number;
  limit: number;
}): Promise<ts.Response<ts.IKindsPcHotSell>> {
  return await get(`${path.newCarApiV3}/kinds/pc/hot/sell`, params);
}

export async function fetchUserIndex(params?: any): Promise<IApiUserIndex> {
  return await get(`${path.newCarApiV2}/u/index`, params);
}

export async function fakerUserFavorAdd(params?: any) {
  return await post(`${path.newCarApiV1}/u/favorAdd`, params);
}

// 意向車款
export async function fetchInquiryKind(params) {
  return await get(`${path.newCarApiV2}/inquiry/kind`, params);
}
export function fetchSaleLeandsHotInquiry(params: any) {
  return get(`${path.newCarApiV3}/saleLeads/hotInquiry`, params);
}

export async function fakeAgentRecommend(params) {
  return await post(`${path.newCarApiV2}/agent/recommend`, params);
}

export async function fetchSaleLeadsBrandDiscount(params) {
  return await get(`${path.newCarApiV3}/saleLeads/brand/discount`, params);
}

// 获取在线人数
export async function fatchOnlineNcarAdd(params) {
  return await get(`${host.www}/online-ncarAdd.html`, params);
}

/** 询价页 - 汰舊換新获取补贴 */
export async function fetchInquiryExpenses(params: any) {
  return await get(`${path.newCarApiV4}/inquiry/expenses`, params);
}

export async function fetchInquiry(params) {
  return await post(`${path.newCarApiV2}/inquiry`, params);
}

// 名单广告询价
export async function fetchInquiryByRoster(params) {
  return await post(`${path.newCarApiV3}/roster`, params);
}

// 重新询价
export async function fetchRepeatRoster(params) {
  return await post(`${path.newCarApiV3}/repeat/roster`, params);
}

// 獲取車型數
export async function fatchModelCount(data) {
  return await get(`${path.newCarApiV2}/modelCount`, data);
}

// 获取在线人数
export async function fatchOnlineNcar(data) {
  return await get(`${host.www}/online-ncar.html`, data);
}

// 獲取用戶信息
export async function fetchUserProfile(params) {
  return await get(`${path.newCarApiV2}/u/userInfo`, params);
}

export async function fakeGeneric(params) {
  return await postGeneric(`https://dc.8891.tw/api/generic`, params);
}

export async function fetchPaging(url) {
  return await get(url);
}
export async function fetchSaleLeadsSoldList(params: { k: string; limit: number }) {
  return await get(`${path.newCarApiV3}/saleLeads/soldList`, params);
}

export async function fetchSaleLeadsAgentDiscounts(params: { k: string; limit: number }) {
  return await get(`${path.newCarApiV3}/saleLeads/agent/discounts`, params);
}

export async function fetchSummaryPictures(params: { k: string }) {
  return await get(`${host.c}/summary/pictures`, params);
}

export async function fetchSummaryKindInfo(params?: any) {
  return await get(`${host.c}/summary/kindInfo`, params);
}

export async function fetchCompareRatingRank(params?: any) {
  return await get(`${path.newCarApiV3}/compare/rating/rank`, params);
}

// 验证码
export async function verificationCode(params) {
  return await post(`${path.newCarApiV2}/u/verificationCode`, params);
}

// 活動詳情
export async function fetchActiveInfo(params: any) {
  return await get(`${path.newCarApiV2}/active/info`, params);
}

export async function fetchKind(id) {
  return await get(`${path.newCarApiV3}/kind/${id}`);
}

// 地區列表
export async function fetchInquiryRegion(params) {
  return await get(`${path.newCarApiV2}/inquiry/region`, params);
}

// 广告獲取地區
export async function getAdRegion(params: any): Promise<ts.IInquiryRegion> {
  return await get(`${path.newCarApiV3}/roster/region`, params);
}

export async function fakeInquiry(params) {
  return await post(`${path.newCarApiV2}/inquiry`, params);
}

export async function fetchSaleLesStatistics() {
  return await get(`${path.newCarApiV3}/saleLeads/statistics`);
}

export async function fetchNewCarBrands(params?: any) {
  return await get(`${path.newCarApiV2}/brand/select`, { type: "base", ...params });
}

export async function fetchNewCarKinds(params?: { b: number }) {
  return await get(`${path.newCarApiV2}/kind/select`, { type: "base", ...params });
}

export async function fetchCampaignsWinners(params?: any) {
  // return await get(`http://127.0.0.1:4523/mock/345128/api/v3/campaigns/buyingParty/winners`, params)
  return await get(`${path.newCarApiV3}/campaigns/buyingParty/winners`, params);
}

// 首页-影音
export async function fetchBuyingPartyMovies(params: { type: "inquiry" | "trial" | "article" }) {
  return await get(`${path.newCarApiV3}/campaigns/buyingParty/movies`, params);
}

// 试用申请历史列表
export async function fetchBuyingPartyAppliedList() {
  return await get(`${path.newCarApiV3}/campaigns/buyingParty/appliedList`);
}

// 好友助力
export async function fakerBuyingPartyTrialAssistance(params: { code: string }) {
  return await post(`${path.newCarApiV3}/campaigns/buyingParty/trial/assistance`, params);
}

// 好友助力数据
export async function fetchBuyingPartyTrialAssistance(params: { code: string }) {
  return await get(`${path.newCarApiV3}/campaigns/buyingParty/trial/assistance`, params);
}

// 活动试用车款申请
export async function fakerBuyingPartyTrialApplied(params: { code: string }) {
  return await post(`${path.newCarApiV3}/campaigns/buyingParty/trial/applied`, params);
}

// 取消活动试用车款申请
export async function fakerBuyingPartyTrialCancelApplied(params: { id: number | string }) {
  return await post(`${path.newCarApiV3}/campaigns/buyingParty/trial/cancel/applied`, params);
}

// 查看试用抽奖卷
export async function fetchBuyingPartyTrialLotteryCodes(params: { id: number | string }) {
  return await get(`${path.newCarApiV3}/campaigns/buyingParty/trial/lotteryCodes`, params);
}

// 歷史開獎名單
export async function fetchBuyingPartyWinners(params: { id: number | string }) {
  return await get(`${path.newCarApiV3}/campaigns/buyingParty/winners`, params);
}

// 试用车款信息
export async function fetchBuyingPartyTrialId(params: { id: number | string }) {
  return await get(`${path.newCarApiV3}/campaigns/buyingParty/trial/${params.id}`, params);
}

// 试用车款列表
export async function fetchBuyingPartyTrial() {
  return await get(`${path.newCarApiV3}/campaigns/buyingParty/trial`);
}
// 热门询价导航
export async function inquiryNav(params?: { from: string }) {
  return await get(`${path.newCarApiV3}/saleLeads/hotInquiry/nav`, params);
}

export async function fetchSaleLeadsBrandList(params) {
  return await get(`${path.newCarApiV3}/saleLeads/brandList`, params);
}
export async function fetchRace(params: any) {
  return await get(`${path.newCarApiV3}/race`, params);
}

export async function fetchReasons(params?: { freeTrialId?: number; limit?: number; page?: number }) {
  return await get(`${path.newCarApiV3}/freeTrial/reasons`, params);
}

export async function freeTrialArticleList(params?: { brandId?: number; limit?: number }) {
  return await get(`${path.newCarApiV3}/freeTrial/article/list`, params);
}

export async function fetchFreeTrialIndedx(params?: any) {
  return await get(`${path.newCarApiV3}/freeTrial`, params);
}

export async function fetchInquiryBuyCarInformationOption(params?: { inquiryId?: string }) {
  return await get(`${path.newCarApiV3}/inquiry/buyCarInformation/option`, params);
}

// type=showroom
export async function fetchBrandSelect(params?: any) {
  return await get(`${path.newCarApiV1}/brand/select`, params);
}

export async function fetchAgentShowRoom(params?: any) {
  return await get(`${path.newCarApiV2}/agent/showroom`, params);
}

export async function fetchAgentServiceType(params?: any) {
  return await get(`${path.newCarApiV2}/agent/service/type`, params);
}

export async function fetchInquiryBuyCarInformation(params?: any) {
  return await post(`${path.newCarApiV3}/inquiry/buyCarInformation`, params);
}

export async function fetchInquiryPreallocate(params: any) {
  return await get(`${path.newCarApiV3}/inquiry/preallocate`, params);
}
// 精選推薦
export async function fetchRecommendArticleChoice(params?: any) {
  return await get(`${path.newCarApiV3}/article/recommend/choice`, params);
}

// 關聯文章列表
export async function fetchRecommendArticleRelated(params?: any) {
  return await get(`${path.newCarApiV3}/article/recommend/related`, params);
}

// tag頁標簽
export async function fetchTags(params?: any) {
  return await get(`${path.newCarApiV3}/tags`, params);
}

// tag頁熱門影音
export async function fetchHotMovie(params?: any) {
  return await get(`${path.newCarApiV3}/movie/hot`, params);
}
// 获取广告参数
export async function fetchUser() {
  return await get(`${path.newCarApiV3}/user`);
}

// tag内頁
export async function fetchTagPolymer(params?: any) {
  return await get(`${path.newCarApiV3}/article/tag/polymer`, params);
}

// 活动影音
export async function fetchActiveMovies(params?: any) {
  return await get(`${path.newCarApiV3}/active/movies`, params);
}

export async function fetchActiveWinner(params?: { name: string }) {
  return await get(`${path.newCarApiV3}/active/winner`, params);
}

// line授权
export async function fetchLineAuth(params?: { code: string; redirectUri: string }) {
  return await post(`${path.newCarApiV3}/active/line/auth`, params);
}

// 找車頁 - 筛选项
export async function fetchGetCarFilterData(params?: any) {
  return await get(`${path.newCarApiV3}/kinds/search/pc/condition`, params);
}

// 找車頁 - 列表
export async function fetchGetCarListData(params?: any) {
  return await get(`${path.newCarApiV3}/kinds/search`, params);
}

// 找車頁 - 厂牌
export async function fetchGetBrandsListData(params?: any) {
  return await get(`${path.newCarApiV3}/kinds/search/pc/brands`, params);
}

// 方案匹配
export async function fetchBidsMatch(params: { brandId: string; region: string; kindId: string }) {
  return await get(`${path.newCarApiV3}/agent/bids/match`, params);
}

// 找車頁 - 新车上市
export async function fetchGetNewCarReleaseListData(params: { y?: string; m?: string; type: string; limit?: number }) {
  return await get(`${path.newCarApiV1}/newlyListedCar`, params);
}

// 找車頁 - 新车上市
export async function fetchNewCarNav(params: { type: string }): Promise<ts.Response<ts.INewCarNav>> {
  return await get(`${path.newCarApiV3}/newlyListedCar/nav`, params);
}

// 找車頁 - 网友热搜
export async function fetchGetNetFriendHotSearch(params?: any) {
  return await get(`${path.newCarApiV3}/kinds/pc/hot/search`, params);
}

// 找車頁 - 厂牌信息
export async function fetchGetBrandsInfoMsg(params?: any) {
  return await get(`${path.newCarApiV3}/brand/info`, params);
}

//播放數統計
export async function fetchPlayCount(data) {
  return await get(`${path.newCarApiV1}/movie/analytics`, data);
}

//pc活动页获取跑马灯数据
export async function fetchMarqueeCount(data) {
  return await get(`${path.newCarApiV3}/campaigns/buy-car-202305/marquee`, data);
}

//pc活动页获取热门车款数据
export async function fetchHotInquiryKind(data) {
  return await get(`${path.newCarApiV3}/campaigns/buy-car-202305/hot-inquiry-kind`, data);
}

//評論消息
export async function fetchPcComments(params) {
  return await get(`${path.newCarApiV1}/movie/pcComments`, params);
}

//获取2024活动车款
export async function fetchBuyCarFeed(params) {
  return await get(`${path.newCarApiV5}/buy-car/feed`, params);
}

//获取2024活动中奖名单
export async function fetchCampaignsInquirySaleWinners(params) {
  return await get(`${path.newCarApiV4}/campaigns/inquiry-sale/winners`, params);
}

export async function fetchAccessRecord(params: { invitationCode: string; source?: string }) {
  return await post(`${path.newCarApiV3}/agent/referral/access/records`, params);
}

export async function fakeVoiceVerificationCode(params: { type: string; mobile: string }) {
  return await post(`${path.newCarApiV3}/voice/verificationCode`, params);
}

export async function fetchBusinessShowroom(params: any) {
  const { id, ...param } = params;
  return await get(`${path.newCarApiV3}/showroom/${id}`, param);
}
export async function fetchOnline() {
  return await get(`${path.newCarApiV3}/online/newcar`, {});
}

// 综述页-关注
export async function fetchV1FavorAdd(params) {
  return await post(`${path.newCarApiV1}/u/favorAdd`, params);
}

// 综述页-评论
export async function fetchKindsumComment(params) {
  return await get(`${host.c}/rating/ratlist`, params);
}

//活動規則
export async function activeRule(params: any) {
  return await get(`${path.newCarApiV3}/active/rule`, params);
}

//購車菜單 - 廠牌 - 跑馬燈
export async function fetchMenuGrandTotal(params: any) {
  return await get(`${path.newCarApiV3}/buycar/menu/grandTotal`, params);
}
// /data/car-model?myid=25084,25083
export async function fetchDataCarModel(params: {b:string;k:string; myid:string }) {
  return await get(`${path.newCarApiV3}/data/car-model`, params);
}


export function postCollectData(data = {}) {
  return post(`${host.dc}/generic`, JSON.stringify(data)).then((res: any) => {
    if (res?.data?.status === 12000) {
      return res.data.data;
    }
    return res.data;
  });
}
